<script>

import Swal from "sweetalert2";
import axios from "axios";

export default {
  page: {
    title: "Profile",
  },
  components: {
  },
  data() {
    return {
      allSocialNetworks: ['instagram', 'facebook', 'youtube', 'blog']
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    connectedSocialNetworks() {
      return this.$store.getters['user/connectedSocialNetworks'];
    }
  },
  methods: {
    async disconnectSocialNetwork(socialNetwork) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#868585",
        confirmButtonText: "Yes, disconnect it!"
      })

      if (!result.value) {
        return;
      }

      await axios.post(`profile/${socialNetwork}/disconnect`)
      // TODO: Return whole profile and update user data using the response
      this.$store.dispatch('user/getUserData');

      Swal.fire("Disconnected!", "Social network has been disconnected.", "success");
    },
  }
};
</script>

<template>
  <div>
    <div class="d-none d-md-block py-1 px-2 mb-2 pricing-header-row">
      <div class="row align-items-center">
        <div class="col-2 text-center">
          <p class="text-muted mb-0">{{ $t('Platform')}}</p>
        </div>
        <div class="col-5 col-md text-center">
          <p class="text-muted mb-0">{{ $t('Username')}}</p>
        </div>
        <div class="col-5 mt-3 mt-md-0">
          <div class="button-container text-right">
            <button  class="btn btn-outline-danger btn-sm invisible"> <i class="bx bx-x mr-1 align-middle font-size-16"></i> Disconnect </button>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-section p-2 mb-2" v-for="socialNetwork in allSocialNetworks" :key="socialNetwork">
      <div class="row align-items-center">
        <div class="order-0 order-sm-0 col-md-2 text-center">
          <div class="social-image-container d-flex align-items-center justify-content-md-center">
            <img v-if="socialNetwork === 'instagram'" src="@/assets/images/brands/instagram.png" class="img-fluid" style="width:28px;" alt="">
            <img v-if="socialNetwork === 'facebook'" src="@/assets/images/brands/facebook.png" class="img-fluid" style="width:28px;" alt="">
            <img v-if="socialNetwork === 'youtube'" src="@/assets/images/brands/youtube.png" class="img-fluid" style="width:28px;" alt="">
            <img v-if="socialNetwork === 'blog'" src="@/assets/images/brands/analytics-logo.png" class="img-fluid" style="width:28px;" alt="">
          </div>
        </div>
        <div class="order-2 order-sm-1 col-md-5 col-sm-12 mt-2 mt-md-0  text-center">
          <p class="text-muted d-md-none mb-1">{{ $t('Username')}}</p>
          <h5 class="mb-0" v-if="connectedSocialNetworks.includes(socialNetwork)"> {{user.social_network_accounts[socialNetwork].username}} </h5>
          <h5 class="mb-0" v-else> Not Connected </h5>
        </div>
        <div class="order-1 order-sm-2 col-md-5 mt-0">
          <div class="button-container text-right">
            <button class="btn btn-outline-danger btn-sm" v-if="connectedSocialNetworks.includes(socialNetwork)" @click="disconnectSocialNetwork(socialNetwork)">
              <i class="bx bx-x mr-1 align-middle font-size-16"></i>Disconnect
            </button>
            <button class="btn btn-outline-info btn-sm" v-else @click="$router.push(`/${socialNetwork}`)">
              <i class="bx bx-link mr-1 align-middle font-size-16"></i>Connect
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
